import { configureStore } from "@reduxjs/toolkit";

import masters from "./masters";
import recharge_managements from "./recharge_managements";
import gift_managements from "./gift_managements";
import broadcast from "./broadcast";
import document from "./document";
import common from "../features/admin/common/Slice";
import dash_map_transport from "../features/admin/dash_map_transport/Slice";
import dash_map_cab from "../features/admin/dash_map_cab/Slice";
import sosrequest from "../features/admin/sosrequest/slice";
import auth from "../features/auth/Slice";
import customization from "./customization";
import customermanagement from "./customer-management";
import usermanagement from "./user-management";
import rolemanagement from "./role-management";
import form from "./form";
import booking from "./booking";
import cab_booking from "./cab_booking";
import share_booking from "./share_booking";
import driver_wallet from "./driver_wallet";
import customer_wallet from "./customer_wallet";
import heat_map from "./heat_map";

export const store = configureStore({
  reducer: {
    auth: auth,
    common: common,
    broadcast,
    document,
    masters,
    recharge_managements,
    gift_managements,
    customization: customization,
    form: form,
    customermanagement: customermanagement,
    usermanagement: usermanagement,
    rolemanagement: rolemanagement,
    sosrequest: sosrequest,
    booking: booking,
    cab_booking: cab_booking,
    share_booking: share_booking,
    driver_wallet: driver_wallet,
    customer_wallet: customer_wallet,
    heat_map: heat_map,
    dash_map_transport: dash_map_transport,
    dash_map_cab: dash_map_cab,
  },
});
